import { seededShuffle } from "@givenwell/components/src/utils/math";
import { GetHomeControllerListingsResponseGroup } from "@givenwell/marketplace-api";
import { queryOptions } from "@tanstack/react-query";
import { api } from "./utils";

export const marketplaceHomeQueryKey = ["marketplace-home"];

export const makeHomeQueryOptions = (searchRadius: number, type: "marketplace" | "eap") =>
  queryOptions({
    queryKey: [...marketplaceHomeQueryKey, { searchRadius, type }],
    queryFn: async () => {
      const results = await api.home.getMarketplaceHome({ searchRadiusMeters: searchRadius, type });
      const shuffledGroups: GetHomeControllerListingsResponseGroup[] = [];
      for (const group of results.groups || []) {
        if (!group.listings.length) continue;

        group.listings = seededShuffle(group.listings, group.name);
        shuffledGroups.push(group);
      }
      return shuffledGroups;
    },
  });
